import { Col, Row } from 'antd';
import 'chart.js/auto';

import styles from './DoughnutBox.module.css';
import DoughnutGrade from './DoughnutGrade';

interface DoughnutBoxProps {
  grade?: number;
  title?: React.ReactNode;
  bottomText?: string;
}

const DoughnutBox: React.FC<DoughnutBoxProps> = ({ grade, bottomText, title }) => {
  return (
    <Row className={styles.doughnutBox__border} justify="center" align="middle">
      <Col>
        {title}
        <DoughnutGrade grade={grade} />
        {bottomText && <Row justify="center">{bottomText}</Row>}
      </Col>
    </Row>
  );
};

export default DoughnutBox;
